<!-- Desktop View -->
<div *appIsDesktop>
  @if (lnOrderHeaderResult) {
    <div id="lnOrderHeader" class="header-container">
      <ds-divider></ds-divider>
      <!-- First Subsection -->
      <div id="firstSubSection" class="first-subSection">
        <div id="firstRow" class="header-row">
          <!-- Order To Name -->
          <div id="lnOrderName">
            <typography variant="mat-caption-1" weight="regular" id="orderToNameLabel" class="info-label">{{ appStrings.lnOrder_toName }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderToNameValue">{{ lnOrderHeaderResult.orderToName }}</typography>
          </div>
          <!-- Order To Address -->
          <div id="lnOrderAddress">
            <typography variant="mat-caption-1" weight="regular" id="orderToAddressLabel" class="info-label">{{ appStrings.lnOrder_toAddress }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderToAddressValue">{{ lnOrderHeaderResult.orderToAddress }}</typography>
          </div>
          <!-- Order To -->
          <div id="lnOrderTo">
            <typography variant="mat-caption-1" weight="regular" id="orderToLabel" class="info-label">{{ appStrings.lnOrder_to }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderToValue">{{ lnOrderHeaderResult.orderToBpNumber }}</typography>
          </div>
          <!-- Order Reference -->
          <div id="reference">
            <typography variant="mat-caption-1" weight="regular" id="orderReferenceLabel" class="info-label">{{ appStrings.lnOrder_reference }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderReferenceValue">
              {{ lnOrderHeaderResult.orderReference ? lnOrderHeaderResult.orderReference : '-' }}
            </typography>
          </div>
        </div>
        <div id="secondRow" class="header-row">
          <!-- PO Number -->
          <div id="poNumber">
            <typography variant="mat-caption-1" weight="regular" id="PONumberLabel" class="info-label">{{ appStrings.invoice_poNumber }}</typography>
            <typography variant="mat-body-2" weight="bold" id="PONumberValue">
              {{ lnOrderHeaderResult.poNumber ? lnOrderHeaderResult.poNumber : '-' }}
            </typography>
          </div>
          <!-- Sales Representative -->
          <div id="salesRepresentative">
            <typography variant="mat-caption-1" weight="regular" id="salesRepLabel" class="info-label">{{ appStrings.invoice_salesRepresentative }}</typography>
            <typography variant="mat-body-2" weight="bold" id="salesRepValue">{{ lnOrderHeaderResult.accountManager }}</typography>
          </div>
          <div id="headerSpace_0">
            <typography variant="mat-caption-1" weight="regular" class="info-label">&nbsp;</typography>
          </div>
          <div id="headerSpace_1">
            <typography variant="mat-caption-1" weight="regular" class="info-label">&nbsp;</typography>
          </div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <!-- Second Subsection -->
      <div id="secondSubSection" class="second-subSection">
        <div id="firstRowSecondSub" class="header-row">
          <!-- Ship To Name -->
          <div id="shipToName">
            <typography variant="mat-caption-1" weight="regular" id="shipToNameLabel" class="info-label">{{ appStrings.invoice_shipToName }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToNameValue">{{ lnOrderHeaderResult.shipToName }}</typography>
          </div>
          <!-- Ship To Address -->
          <div id="shipToAddress">
            <typography variant="mat-caption-1" weight="regular" id="shipToAddressLabel" class="info-label">{{ appStrings.invoice_shipToAddress }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToAddressValue">{{ lnOrderHeaderResult.shipToAddress }}</typography>
          </div>
          <!-- Ship To BP -->
          <div id="shipTo">
            <typography variant="mat-caption-1" weight="regular" id="shipToLabel" class="info-label">{{ appStrings.invoice_shipTo }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToValue">{{ lnOrderHeaderResult.shipToBp }}</typography>
          </div>
          <!-- Order Date-->
          <div id="date">
            <typography variant="mat-caption-1" weight="regular" id="orderDateLabel" class="info-label">{{ appStrings.orderDetails__orderDate }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderDateValue">{{ lnOrderHeaderResult.orderDate | date: dateFormat }}</typography>
          </div>
        </div>
        <div id="secondRowSecondSub" class="header-row">
          <!-- Order Number -->
          <div id="orderNumber">
            <typography variant="mat-caption-1" weight="regular" id="orderNumberLabel" class="info-label">{{ appStrings.invoice_orderNumber }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderNumberValue">{{ lnOrderHeaderResult.orderNumber }}</typography>
          </div>
          <div id="headerSpace_2">
            <typography class="info-label">&nbsp;</typography>
          </div>
          <div id="headerSpace_3">
            <typography class="info-label">&nbsp;</typography>
          </div>
          <div id="headerSpaceSecond_4">
            <typography class="info-label">&nbsp;</typography>
          </div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <!-- Third subsection -->
      <div id="thirdSubSection" class="third-subSection">
        <div id="firstRowThirdSub" class="header-row">
          <!-- Subtotal -->
          <div id="subtotal">
            <typography variant="mat-caption-1" weight="regular" id="subtotalLabel" class="info-label">{{ appStrings.lnOrder_subtotal }}</typography>
            <typography variant="mat-body-2" weight="bold" id="subtotalValue">
              {{ !lnOrderHeaderResult.subTotal ? '-' :
              lnOrderHeaderResult.subTotal | currency: lnOrderHeaderResult.currencySign }}
            </typography>
          </div>
          <!-- Shipping and Handling -->
          <div id="shipAndHandle">
            <typography variant="mat-caption-1" weight="regular" id="shipAndHandleLabel" class="info-label">{{ appStrings.lnOrder_shipAndHandle }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipAndHandleValue">
              {{ !lnOrderHeaderResult.shippingAndHandling ? '-' :
              lnOrderHeaderResult.shippingAndHandling | currency: lnOrderHeaderResult.currencySign }}
            </typography>
          </div>
          <!-- Tax -->
          <div id=" tax">
            <typography variant="mat-caption-1" weight="regular" id="taxLabel" class="info-label">{{ appStrings.lnOrder_tax }}</typography>
            <typography variant="mat-body-2" weight="bold" id="taxValue">
              {{ !lnOrderHeaderResult.tax ? '-' :
              lnOrderHeaderResult.tax | currency: lnOrderHeaderResult.currencySign }}
            </typography>
          </div>
          <!-- Total Amount -->
          <div id="totalAmount">
            <typography variant="mat-caption-1" weight="regular" id="totalAmountLabel" class="info-label">{{ appStrings.invoice_totalAmount }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalAmountValue">
              {{ !lnOrderHeaderResult.totalAmount ? '-' :
              lnOrderHeaderResult.totalAmount| currency: lnOrderHeaderResult.currencySign }}
            </typography>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<!-- Mobile View -->
<div class="mobile" *appIsMobile>
  @if (lnOrderHeaderResult) {
    <div id="lnOrderHeaderMobile" class="mobile">
      <ds-divider></ds-divider>
      <!-- First Section -->
      <div id="firstSubSectionMobile" class="first-subSection">
        <div id="firstRowMobile" class="header-row">
          <div id="lnOrderNameMobile">
            <typography variant="mat-caption-1" weight="regular" id="orderToNameLabelMobile" class="info-label">{{ appStrings.lnOrder_toName }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderToNameValueMobile">{{ lnOrderHeaderResult.orderToName }}</typography>
          </div>
          <div id="lnOrderToMobile">
            <typography variant="mat-caption-1" weight="regular" id="orderToLabelMobile" class="info-label">{{ appStrings.lnOrder_to }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderToValueMobile">{{ lnOrderHeaderResult.orderToBpNumber }}</typography>
          </div>
        </div>
        <div id="secondRowMobile" class="header-row">
          <div id="lnOrderAddressMobile">
            <typography variant="mat-caption-1" weight="regular" id="orderToAddressLabelMobile" class="info-label">{{ appStrings.lnOrder_toAddress }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderToAddressValueMobile">{{ lnOrderHeaderResult.orderToAddress }}</typography>
          </div>
        </div>
        <div id="thirdRowMobile" class="header-row">
          <div id="referenceMobile">
            <typography variant="mat-caption-1" weight="regular" id="orderReferenceLabelMobile" class="info-label">{{ appStrings.lnOrder_reference }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderReferenceValueMobile">{{ lnOrderHeaderResult.orderReference || '-' }}</typography>
          </div>
          <div id="salesRepresentativeMobile">
            <typography variant="mat-caption-1" weight="regular" id="salesRepLabelMobile" class="info-label">{{ appStrings.invoice_salesRepresentative }}</typography>
            <typography variant="mat-body-2" weight="bold" id="salesRepValueMobile">{{ lnOrderHeaderResult.accountManager }}</typography>
          </div>
        </div>
        <div id="fourthRowMobile" class="header-row">
          <div id="poNumberMobile">
            <typography variant="mat-caption-1" weight="regular" id="PONumberLabelMobile" class="info-label">{{ appStrings.invoice_poNumber }}</typography>
            <typography variant="mat-body-2" weight="bold" id="PONumberValueMobile">{{ lnOrderHeaderResult.poNumber || '-' }}</typography>
          </div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <!-- Second Section -->
      <div id="secondSubSectionMobile" class="second-subSection">
        <div id="firstRowSecondSubMobile" class="header-row">
          <div id="shipToNameMobile">
            <typography variant="mat-caption-1" weight="regular" id="shipToNameLabelMobile" class="info-label">{{ appStrings.invoice_shipToName }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToNameValueMobile">{{ lnOrderHeaderResult.shipToName }}</typography>
          </div>
        </div>
        <div id="secondRowSecondSubMobile" class="header-row">
          <div id="shipToMobile">
            <typography variant="mat-caption-1" weight="regular" id="shipToLabelMobile" class="info-label">{{ appStrings.invoice_shipTo }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToValueMobile">{{ lnOrderHeaderResult.shipToBp }}</typography>
          </div>
        </div>
        <div id="thirdRowSecondSubMobile" class="header-row">
          <div id="shipToAddressMobile">
            <typography variant="mat-caption-1" weight="regular" id="shipToAddressLabelMobile" class="info-label">{{ appStrings.invoice_shipToAddress }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipToAddressValueMobile">{{ lnOrderHeaderResult.shipToAddress }}</typography>
          </div>
          <div id="dateMobile">
            <typography variant="mat-caption-1" weight="regular" id="orderDateLabelMobile" class="info-label">{{ appStrings.orderDetails__orderDate }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderDateValueMobile">{{ lnOrderHeaderResult.orderDate | date: appInfoService.dateFormat }}</typography>
          </div>
        </div>
        <div id="fourthRowSecondSubMobile" class="header-row">
          <div id="orderNumberMobile">
            <typography variant="mat-caption-1" weight="regular" id="orderNumberLabelMobile" class="info-label">{{ appStrings.invoice_orderNumber }}</typography>
            <typography variant="mat-body-2" weight="bold" id="orderNumberValueMobile">{{ lnOrderHeaderResult.orderNumber }}</typography>
          </div>
          <div id="headerSpaceMobile_0"></div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <!-- Third Section -->
      <div id="thirdSubSectionMobile" class="third-subSection">
        <div id="firstRowThirdSubMobile" class="header-row">
          <div id="subtotalMobile">
            <typography variant="mat-caption-1" weight="regular" id="subtotalLabelMobile" class="info-label">{{ appStrings.lnOrder_subtotal }}</typography>
            <typography variant="mat-body-2" weight="bold" id="subtotalValueMobile">
              {{ !lnOrderHeaderResult.subTotal ? '-' : (lnOrderHeaderResult.subTotal | currency: lnOrderHeaderResult.currencySign) }}
            </typography>
          </div>
          <div id="shipAndHandleMobile">
            <typography variant="mat-caption-1" weight="regular" id="shipAndHandleLabelMobile" class="info-label">{{ appStrings.lnOrder_shipAndHandle }}</typography>
            <typography variant="mat-body-2" weight="bold" id="shipAndHandleValueMobile">
              {{ !lnOrderHeaderResult.shippingAndHandling ? '-' : (lnOrderHeaderResult.shippingAndHandling | currency: lnOrderHeaderResult.currencySign) }}
            </typography>
          </div>
        </div>
        <div id="secondRowThirdSubMobile" class="header-row">
          <div id="taxMobile">
            <typography variant="mat-caption-1" weight="regular" id="taxLabelMobile" class="info-label">{{ appStrings.lnOrder_tax }}</typography>
            <typography variant="mat-body-2" weight="bold" id="taxValueMobile">
              {{ !lnOrderHeaderResult.tax ? '-' : (lnOrderHeaderResult.tax | currency: lnOrderHeaderResult.currencySign) }}
            </typography>
          </div>
          <div id="totalAmountMobile">
            <typography variant="mat-caption-1" weight="regular" id="totalAmountLabelMobile" class="info-label">{{ appStrings.invoice_totalAmount }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalAmountValueMobile">
              {{ !lnOrderHeaderResult.totalAmount ? '-' : (lnOrderHeaderResult.totalAmount | currency: lnOrderHeaderResult.currencySign) }}
            </typography>
          </div>
        </div>
      </div>
    </div>
  }
</div>
